<template>
  <div id="app" ref="appContainer">
    <Header />
    <main>
      <router-view />
    </main>
    <Footer />
    
    <!-- 滚动按钮 -->
    <div class="scroll-buttons">
      <button class="scroll-btn scroll-up" @click="scrollUp" title="向上滚动">
        <span class="triangle-up"></span>
      </button>
      <button class="scroll-btn scroll-down" @click="scrollDown" title="向下滚动">
        <span class="triangle-down"></span>
      </button>
    </div>
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "App",
  components: {
    Header,
    Footer,
  },
  mounted() {
    let link = "./favicon.ico";
    let $favicon = document.querySelector('link[rel="icon"]');
    if ($favicon !== null) {
      $favicon.href = link;
    } else {
      $favicon = document.createElement("link");
      $favicon.rel = "icon";
      $favicon.href = link;
      document.head.appendChild($favicon);
    }
    // 监听滚动到顶部事件
    this.$bus.on('scrollTop', this.scrollTop);
  },
  beforeUnmount() {
    // 移除事件监听，避免内存泄漏
    this.$bus.off('scrollTop', this.scrollTop);
  },
  methods: {
    // 获取滚动容器
    getScrollContainer() {
      return this.$refs.appContainer;
    },
    
    // 向上滚动50vh
    scrollUp() {
      const container = this.getScrollContainer();
      const scrollAmount = container.clientHeight;
      container.scrollBy({ top: -scrollAmount, behavior: 'smooth' });
    },
    
    // 向下滚动50vh
    scrollDown() {
      const container = this.getScrollContainer();
      const scrollAmount = container.clientHeight;
      container.scrollBy({ top: scrollAmount, behavior: 'smooth' });
    },
    // 滚动到顶部
    scrollTop() {
      const container = this.getScrollContainer();
      container.scrollTo({ top: 0, left: 0 });
    }
  }
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  height: 100%;
  overflow: hidden; /* 改为 hidden，让 #app 处理滚动 */
}

body {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: transparent;
  color: #fff;
}

#app {
  height: 100vh;
  overflow-y: auto;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
}

main {
  flex: 1;
}

/* 自定义滚动条样式 */
::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
}

::-webkit-scrollbar-thumb {
  background: rgba(20, 20, 20, 0.3);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(50, 50, 50, 0.5);
}

/* 滚动按钮样式 */
.scroll-buttons {
  position: fixed;
  right: 20px;
  bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 999;
}

.scroll-btn {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.scroll-btn:hover {
  background: rgba(0, 0, 0, 0.8);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
}

.scroll-btn:active {
  transform: translateY(0);
}

/* 三角形图标样式 */
.triangle-up,
.triangle-down {
  display: inline-block;
  width: 0;
  height: 0;
  border-style: solid;
}

.triangle-up {
  border-width: 0 6px 10px 6px;
  border-color: transparent transparent #ffffff transparent;
}

.triangle-down {
  border-width: 10px 6px 0 6px;
  border-color: #ffffff transparent transparent transparent;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .scroll-buttons {
    right: 15px;
    bottom: 15px;
  }
  
  .scroll-btn {
    width: 36px;
    height: 36px;
  }
  
  .triangle-up {
    border-width: 0 5px 8px 5px;
  }
  
  .triangle-down {
    border-width: 8px 5px 0 5px;
  }
}
</style>